export default "/images/vendor/@coreui/icons/svg/flag/cif-qa.svg?87c88bc5a562e4101a6474daf1788f23";